import React from "react";
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { matchOptions } from "../utils/function";
import { optionsBranch } from "../data/branch-data";
import { internType } from "../data/interntype-data";

const JobDetail = ({ itemSelected }) => {
  const displayCompany = (
    <>
      <Divider>
        <Typography variant="h6" style={{ fontWeight: 600 }} my={2}>
          สถานประกอบการ
        </Typography>
      </Divider>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextWithLabel
            label="ชื่อสถานประกอบการ - ไทย"
            content={itemSelected?.job_data?.company?.company_thainame}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextWithLabel
            label="ชื่อสถานประกอบการ - อังกฤษ"
            content={itemSelected?.job_data?.company?.company_engname}
          />
        </Grid>
        <Grid item xs={12}>
          <TextWithLabel
            label="ที่อยู่"
            content={`  ${itemSelected?.job_data?.company?.address} 
              ${itemSelected?.job_data?.company?.sub_district} 
              ${itemSelected?.job_data?.company?.district} 
              ${itemSelected?.job_data?.company?.province} 
              ${itemSelected?.job_data?.company?.zip_code}`}
          />
        </Grid>
        <Grid item xs={12}>
          <TextWithLabel
            label="ประเภทธุรกิจ"
            content={itemSelected?.job_data?.company?.company_type}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextWithLabel
            label="จำนวนพนักงาน"
            content={itemSelected?.job_data?.company?.employees_qty}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextWithLabel
            label="จำนวนวันที่ทำงาน / สัปดาห์"
            content={itemSelected?.job_data?.company?.working_days}
          />
        </Grid>
      </Grid>
    </>
  );

  const displayContactPerson = (
    <>
      <Divider>
        <Typography variant="h6" style={{ fontWeight: 600 }} my={2}>
          ผู้ประสานงาน
        </Typography>
      </Divider>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextWithLabel
            label="ชื่อผู้ประสานงาน"
            content={itemSelected?.job_data?.contact?.full_name}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextWithLabel
            label="ตำแหน่ง"
            content={itemSelected?.job_data?.contact?.position}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextWithLabel
            label="E-mail"
            content={itemSelected?.job_data?.contact?.email}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextWithLabel
            label="เบอร์โทรที่ติดต่อได้"
            content={
              itemSelected?.job_data?.contact?.contact_availabel?.type === "2"
                ? `${itemSelected?.job_data?.contact?.contact_availabel?.type} (เบอร์อื่น)`
                : `${itemSelected?.job_data?.contact?.tel} (เบอร์ผู้ประสานงาน)`
            }
          />
        </Grid>
      </Grid>
    </>
  );

  const displayWelfare = (
    <>
      <Divider>
        <Typography variant="h6" style={{ fontWeight: 600 }} my={2}>
          สวัสดิการ
        </Typography>
      </Divider>

      <Grid container spacing={2}>
        {itemSelected?.job_data?.welfare?.dorm?.have && (
          <Grid item xs={12} sm={6}>
            <TextWithLabel
              label="หอพัก"
              content={
                itemSelected?.job_data?.welfare?.dorm?.expense
                  ? `มีบริการ มีค่าใช้จ่าย ${
                      itemSelected?.job_data?.welfare?.dorm?.price ?? 0
                    } / เดือน`
                  : "มีบริการ ไม่มีค่าใช้จ่าย"
              }
            />
          </Grid>
        )}
        {itemSelected?.job_data?.welfare?.food?.have && (
          <Grid item xs={12} sm={6}>
            <TextWithLabel
              label="อาหารกลางวัน"
              content={`มี ${itemSelected?.job_data?.welfare?.food?.remark}`}
            />
          </Grid>
        )}
        {itemSelected?.job_data?.welfare?.salary?.have && (
          <Grid item xs={12} sm={6}>
            <TextWithLabel
              label="ค่าตอบแทน"
              content={`${itemSelected?.job_data?.welfare?.salary?.wage} บาท / วัน`}
            />
          </Grid>
        )}
        {itemSelected?.job_data?.welfare?.transportation?.have && (
          <Grid item xs={12} sm={6}>
            <TextWithLabel
              label="รถรับส่ง"
              content={
                itemSelected?.job_data?.welfare?.transportation?.expense
                  ? `มีบริการ มีค่าใช้จ่าย ${
                      itemSelected?.job_data?.welfare?.transportation?.price ??
                      0
                    } / เดือน`
                  : "มีบริการ ไม่มีค่าใช้จ่าย"
              }
            />
          </Grid>
        )}
        {itemSelected?.job_data?.welfare?.other?.remark &&
          itemSelected?.job_data?.welfare?.other?.remark !== "-" && (
            <Grid item xs={12} sm={6}>
              <TextWithLabel
                label="อื่น ๆ"
                content={itemSelected?.job_data?.welfare?.other?.remark}
              />
            </Grid>
          )}
      </Grid>
    </>
  );

  const displayBranch = (
    <>
      <Divider>
        <Typography variant="h6" color="" style={{ fontWeight: 600 }} my={2}>
          สาขาที่เปิดรับ
        </Typography>
      </Divider>

      {itemSelected?.job_data?.branchs
        ?.filter((el) => el.allow)
        .map((item, index) => {
          return (
            <>
              <Grid container spacing={2} mb={2}>
                <Grid item xs={12} sm={6}>
                  <TextWithLabel
                    label="สาขา"
                    content={
                      <Typography variant="body1">
                        {matchOptions(optionsBranch, item.b_id)}
                      </Typography>
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextWithLabel label="เกรดเฉลี่ย" content={`${item.gpax}`} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextWithLabel
                    label="ตำแหน่ง"
                    content={`${item.position_title}`}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextWithLabel
                    label="จำนวนเปิดรับ"
                    content={`${item.intern_qty} ตำแหน่ง`}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextWithLabel label="เพศ" content={`${item.gender}`} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextWithLabel
                    label="ความสามารถภาษาอังกฤษ"
                    content={`${item.eng_ability}`}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextWithLabel
                    label="ความสามารถด้านคอมพิวเตอร์"
                    content={`${item.programming_ability}`}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextWithLabel
                    label="ความสามารถอื่น ๆ"
                    content={`${item.other_ability}`}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextWithLabel
                    label="รายละเอียดงาน"
                    content={`${item.job_description}`}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextWithLabel
                    label="โปรเจ็คบริษัท"
                    content={`${item.project.have ? "มี" : "ไม่มี"} ${
                      item.project.remark
                    }`}
                  />
                </Grid>
                {item.period && (
                  <Grid item xs={12}>
                    <TextWithLabel
                      label="ช่วงเวลา"
                      content={
                        item.period.type == "0"
                          ? `อื่น ๆ ${item.period.remark}`
                          : matchOptions(internType, item.period.type)
                      }
                    />
                  </Grid>
                )}
              </Grid>
              <hr />
              {(index + 1) % 2 == 0 && <div className="page-break" />}
            </>
          );
        })}
    </>
  );

  return (
    <div>
      <Box padding={2}>
        {displayCompany}
        {displayContactPerson}
        {displayWelfare}
        <div className="page-break" />
        {displayBranch}
      </Box>
    </div>
  );
};

export default JobDetail;

const TextWithLabel = ({ label, content }) => {
  return (
    <Stack>
      <Typography variant="caption" color="gray" style={{ fontWeight: 600 }}>
        {label}
      </Typography>
      <Typography variant="" color="blue">
        {content}
      </Typography>
    </Stack>
  );
};
